module.exports = __webpack_public_path__ + "img/14.d17cd267.jpg";